import React from "react";
import { FormattedMessage } from "react-intl";

import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "~/common/redesign-v1";
import { Download, IosShare, Plus } from "~/common/redesign-v1/icons";

export function RedesignInstallAppModal({ open, ios, onInstall, onDismiss }: { open: boolean; ios: boolean; onInstall(): void; onDismiss(): void }) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onDismiss()}>
      <DialogContent data-testid="rd-pwa-install-modal" className="tw-max-w-sm tw-items-center tw-text-center">
        <div className="tw-flex tw-size-16 tw-items-center tw-justify-center tw-rounded-full tw-bg-muted">
          <Download className="tw-size-7 tw-text-foreground" />
        </div>
        <DialogHeader>
          <DialogTitle>
            <FormattedMessage id={ios ? "redesign.pwa.install.title.ios" : "redesign.pwa.install.title.android"} />
          </DialogTitle>
          <DialogDescription>
            <FormattedMessage id={ios ? "redesign.pwa.install.body.ios" : "redesign.pwa.install.body.android"} />
          </DialogDescription>
        </DialogHeader>
        {ios ? (
          <ol className="tw-m-0 tw-flex tw-w-full tw-list-none tw-flex-col tw-gap-3 tw-p-0 tw-text-left">
            <li className="tw-flex tw-items-center tw-gap-3">
              <span className="tw-flex tw-size-9 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-muted">
                <IosShare className="tw-size-4 tw-text-foreground" />
              </span>
              <span className="tw-text-sm tw-text-foreground">
                <FormattedMessage id="redesign.pwa.install.step.ios.share" />
              </span>
            </li>
            <li className="tw-flex tw-items-center tw-gap-3">
              <span className="tw-flex tw-size-9 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-muted">
                <Plus className="tw-size-4 tw-text-foreground" />
              </span>
              <span className="tw-text-sm tw-text-foreground">
                <FormattedMessage id="redesign.pwa.install.step.ios.add" />
              </span>
            </li>
          </ol>
        ) : null}
        <DialogFooter>
          <Button type="button" className="tw-w-full" data-testid="rd-pwa-install-cta" onClick={ios ? onDismiss : onInstall}>
            <FormattedMessage id={ios ? "redesign.pwa.install.cta.ios" : "redesign.pwa.install.cta.android"} />
          </Button>
          {ios ? null : (
            <Button type="button" variant="ghost" className="tw-w-full" data-testid="rd-pwa-install-dismiss" onClick={onDismiss}>
              <FormattedMessage id="redesign.pwa.install.dismiss" />
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
